export class MembershipActivityRow {
  public MembershipLevel: string;
  public NewMembers: number;
  public NewInvestment: number;
  public DroppedMembers: number;
  public LostInvestment: number;
  public GainLoss: number;
  public GainLossInvestment: number;
  public TotalMembers: number;

  public constructor() {
    this.MembershipLevel = '';
    this.NewMembers = 0;
    this.NewInvestment = 0;
    this.DroppedMembers = 0;
    this.LostInvestment = 0;
    this.GainLoss = 0;
    this.GainLossInvestment = 0;
    this.TotalMembers = 0;
  }
}
